angular.module('app').directive('hueDbColorFrequencyPharmaExpand', function () {
  function link(scope, element, attrs) {
    scope.tooltipsterConfig = {
      animation: 'fade',
      theme: 'tooltipster-default',
      trigger: 'custom',
      position: 'bottom'
    };

    scope.activeIndex = 0;
    scope.data = null;
    scope.selectedBar = null;

    scope.expandedGroupClass = null;
    scope.expandStatus = {
      'expand-group-most-used': false,
      'expand-group-moderately-used': false,
      'expand-group-least-used': false,
      'expand-group-not-used': false
    };
    scope.setExpandedGroupClass = function (groupClass) {
      scope.expandedGroupClass = groupClass;

      if (groupClass === 'expand-group-most-used') {
        scope.expandStatus['expand-group-most-used'] = true;
        scope.expandStatus['expand-group-moderately-used'] = false;
        scope.expandStatus['expand-group-least-used'] = false;
        scope.expandStatus['expand-group-not-used'] = false;
      } else if (groupClass === 'expand-group-moderately-used') {
        scope.expandStatus['expand-group-most-used'] = false;
        scope.expandStatus['expand-group-moderately-used'] = true;
        scope.expandStatus['expand-group-least-used'] = false;
        scope.expandStatus['expand-group-not-used'] = false;
      } else if (groupClass === 'expand-group-least-used') {
        scope.expandStatus['expand-group-most-used'] = false;
        scope.expandStatus['expand-group-moderately-used'] = false;
        scope.expandStatus['expand-group-least-used'] = true;
        scope.expandStatus['expand-group-not-used'] = false;
      } else if (groupClass === 'expand-group-not-used') {
        scope.expandStatus['expand-group-most-used'] = false;
        scope.expandStatus['expand-group-moderately-used'] = false;
        scope.expandStatus['expand-group-least-used'] = false;
        scope.expandStatus['expand-group-not-used'] = true;
      } else {
        scope.expandStatus['expand-group-most-used'] = false;
        scope.expandStatus['expand-group-moderately-used'] = false;
        scope.expandStatus['expand-group-least-used'] = false;
        scope.expandStatus['expand-group-not-used'] = false;
      }
    };
    scope.showSearchedColor = function () {
      return scope.searchedColor != null;
    };
    scope.getClass = function () {
      var result = [];
      if (scope.expandedGroupClass)
        result.push(scope.expandedGroupClass);
      if (scope.showSearchedColor())
        result.push('with-searched-color');

      return result.join(' ');
    };

    scope.selectBar = function (event) {
      if (scope.selectedBar == event.target) {
        angular.element(scope.selectedBar).tooltipster('hide');
        scope.selectedBar = null;
      } else {
        if (scope.selectedBar)
          angular.element(scope.selectedBar).tooltipster('hide');

        angular.element(event.target).tooltipster('show');
        scope.selectedBar = event.target;
      }
    };

    scope.getMostWidth = function (index) {
      let totalPercentage = 0;
      scope.data.mostPopular.forEach(item => {
        if(typeof(item.percentage) == "string") {
          totalPercentage += parseFloat(item.percentage);
        } else {
          totalPercentage += item.percentage;
        }
      });
      let indexPercentage = scope.data.mostPopular[index] ? scope.data.mostPopular[index].percentage : 0;
        return parseFloat((100 / totalPercentage) * indexPercentage) + '%';
    }

    scope.getModerateWidth = function (index) {
      let totalPercentage = 0;
      scope.data.moderate.forEach(item => {
        if(typeof(item.percentage) == "string") {
          totalPercentage += parseFloat(item.percentage);
        } else {
          totalPercentage += item.percentage;
        }
      });
      let indexPercentage = scope.data.moderate[index] ? scope.data.moderate[index].percentage : 0;
        return parseFloat((100 / totalPercentage) * indexPercentage) + '%';
    }

    scope.getInfrequentWidth = function (index) {
      let totalPercentage = 0;
      scope.data.infrequent.forEach(item => {
        if(typeof(item.percentage) == "string") {
          totalPercentage += parseFloat(item.percentage);
        } else {
          totalPercentage += item.percentage;
        }
      });
      let indexPercentage = scope.data.infrequent[index] ? scope.data.infrequent[index].percentage : 0;
        return parseFloat((100 / totalPercentage) * indexPercentage) + '%';
    }

    scope.getNotUsedWidth = function (index) {
      let totalPercentage = 0;
      scope.data.not_used.forEach(item => {
        if(typeof(item.percentage) == "string") {
          totalPercentage += parseFloat(item.percentage);
        } else {
          totalPercentage += item.percentage;
        }
      });
      let indexPercentage = 0;
      indexPercentage = scope.data.not_used[index] ? scope.data.not_used[index].percentage : 0;
      return parseFloat((100 / totalPercentage) * indexPercentage) + '%';
    }

    scope.$watch('originalData', function (newValue, oldValue) {
      if (newValue instanceof Array)
        scope.data = newValue[scope.activeColor];
      else
        scope.data = newValue;
    });

    scope.$watch('activeColor', function (newValue, oldValue) {
      if (scope.originalData instanceof Array && newValue != null)
        scope.data = scope.originalData[newValue];
    });
  }

  return {
    restrict: 'E',
    templateUrl: 'app/directives/dbColorFrequencyPharmaExpand/dbColorFrequencyPharmaExpandView.html',
    link: link,
    scope: {
      originalData: '=data',
      searchedColor: '=',
      activeColor: '='
    }
  };
});
